/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/


import {FETCH_ADDITIONAL_DOCUMENT_REQUEST, FETCH_ADDITIONAL_DOCUMENT_SUCCESS, FETCH_ADDITIONAL_DOCUMENT_FAILURE, FETCH_DELETE_ADDITIONAL_DOCUMENT_REQUEST, FETCH_DELETE_ADDITIONAL_DOCUMENT_SUCCESS, FETCH_DELETE_ADDITIONAL_DOCUMENT_FAILURE} from './AdditionalDocumentTypes';
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";
import APIManager from '../../ApiManager/ApiManager';

export const fetchAdditonalDocumentRequest = () => {
    return {
      type: FETCH_ADDITIONAL_DOCUMENT_REQUEST,
    };
  };
  
  export const fetchAdditonalDocumentSuccess = (additionalDocument) => {
    return {
      type: FETCH_ADDITIONAL_DOCUMENT_SUCCESS,
      payload: additionalDocument,
    };
  };
  
  export const fetchAdditonalDocumentFailure = (error) => {
    return {
      type: FETCH_ADDITIONAL_DOCUMENT_FAILURE,
      payload: error,
    };
  };

  export const fetchDeleteAdditionalDocumentRequest=()=>{
    return{
      type: FETCH_DELETE_ADDITIONAL_DOCUMENT_REQUEST
    }
  }

  export const fetchDeleteAdditionalDocumentSuccess=()=>{
    return {
      type:FETCH_DELETE_ADDITIONAL_DOCUMENT_SUCCESS
    }
  }

  export const fetchDeleteAdditionalDocumentFailure=(payload)=>{
    return{
      type:FETCH_DELETE_ADDITIONAL_DOCUMENT_FAILURE,
      error:payload
    }
  }
  
  export const fetchAdditionalDocumentDetails = (applicationId, submissionId, file) => {
    return async function (dispatch) {
      dispatch(fetchAdditonalDocumentRequest());
      try {
        const data = await APIManager.uploadAdditionalDocument(applicationId, submissionId, file);
        dispatch(fetchAdditonalDocumentSuccess(data));
      } catch (error) {
        dispatch(fetchAdditonalDocumentFailure(error));
        dispatch(commonError(error,FETCH_ADDITIONAL_DOCUMENT_FAILURE));
      }
    };
  };

  export const fetchDeleteAdditionalDocument=(applicationId, submissionId, fileName)=>{
    return async function (dispatch) {
      dispatch(fetchDeleteAdditionalDocumentRequest());
      try {
        await APIManager.deleteAdditionalDocument(
          applicationId,
          submissionId,
          fileName
        );
        dispatch(fetchDeleteAdditionalDocumentSuccess());
      } catch (error) {
        dispatch(fetchDeleteAdditionalDocumentFailure(error));
        dispatch(commonError(error, FETCH_DELETE_ADDITIONAL_DOCUMENT_FAILURE));
      }
  }
}

  export const commonError=(error,errorType)=>{
    return({
      type:COMMON_ERROR,
      payload:{
        message:error.message,
        errorType:errorType
      }
    })
  }